import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrganisations,
  fetchOrganisationById,
  createOrganisation,
  updateOrganisation as updateOrganisationThunk,
  addProjectToOrganisation,
  removeProjectFromOrganisation,
  deleteOrganisation as deleteOrganisationThunk,
  fetchUnassignedProjects,
  fetchAvailableClients,
  addExistingClient as addExistingClientThunk,
  inviteClient as inviteClientThunk,
  clearSelectedOrganisation,
  resetCreateOrganisation,
  resetInviteClient,
  clearOrganisationErrors,
} from "../store/slices/organisationSlice";

const useOrganisation = () => {
  const dispatch = useDispatch();

  const {
    organisations,
    selectedOrganisation,
    unassignedProjects,
    availableClients,
    isFetchingAvailableClients,
    isAddingExistingClient,
    addExistingClientError,

    isFetchingOrganisations,
    isFetchingOrganisation,
    isCreatingOrganisation,
    isUpdatingOrganisation,
    isAddingProject,
    isRemovingProject,
    isDeletingOrganisation,
    isFetchingUnassigned,
    isInvitingClient,

    organisationsError,
    organisationError,
    createOrganisationError,
    updateOrganisationError,
    addProjectError,
    removeProjectError,
    deleteOrganisationError,
    inviteClientError,

    createOrganisationSuccess,
    inviteClientSuccess,
  } = useSelector((state) => state.organisation);

  return {
    // ── State ──────────────────────────────
    organisations,
    selectedOrganisation,
    unassignedProjects,
    availableClients,
    createOrganisationSuccess,
    inviteClientSuccess,
    isFetchingAvailableClients,
    isAddingExistingClient,
    addExistingClientError,

    // ── Loading ────────────────────────────
    isFetchingOrganisations,
    isFetchingOrganisation,
    isCreatingOrganisation,
    isUpdatingOrganisation,
    isAddingProject,
    isRemovingProject,
    isDeletingOrganisation,
    isFetchingUnassigned,
    isInvitingClient,

    // ── Errors ─────────────────────────────
    organisationsError,
    organisationError,
    createOrganisationError,
    updateOrganisationError,
    addProjectError,
    removeProjectError,
    deleteOrganisationError,
    inviteClientError,

    // ── Actions ────────────────────────────
    loadOrganisations: () => dispatch(fetchOrganisations()),
    loadOrganisation: (organisationId) =>
      dispatch(fetchOrganisationById(organisationId)),
    makeOrganisation: (payload) => dispatch(createOrganisation(payload)),
    editOrganisation: (organisationId, payload) =>
      dispatch(updateOrganisationThunk({ organisationId, ...payload })),
    attachProject: (organisationId, projectId) =>
      dispatch(addProjectToOrganisation({ organisationId, projectId })),
    detachProject: (organisationId, projectId) =>
      dispatch(removeProjectFromOrganisation({ organisationId, projectId })),
    removeOrganisation: (organisationId, mode) =>
      dispatch(deleteOrganisationThunk({ organisationId, mode })),
    loadUnassignedProjects: () => dispatch(fetchUnassignedProjects()),
    loadAvailableClients: (organisationId) =>
      dispatch(fetchAvailableClients(organisationId)),
    addClient: (organisationId, userId) =>
      dispatch(addExistingClientThunk({ organisationId, userId })),
    sendClientInvite: (organisationId, payload) =>
      dispatch(inviteClientThunk({ organisationId, ...payload })),

    clearOrganisation: () => dispatch(clearSelectedOrganisation()),
    resetCreate: () => dispatch(resetCreateOrganisation()),
    resetInvite: () => dispatch(resetInviteClient()),
    clearErrors: () => dispatch(clearOrganisationErrors()),
  };
};

export default useOrganisation;
